<template>
    <div>
        <div @click="onOpen" :class="openClasses" title="Manage my charts" class="flex items-center px-30 h-56">
            <!-- layers icon-->
            <svg :class="iconClasses" xmlns="http://www.w3.org/2000/svg" width="16" height="11.68" viewBox="0 0 16 11.68">
                <g id="Group_291" data-name="Group 291" transform="translate(-1231.179 -24.046)">
                <path id="Subtraction_43_1_" d="M890.82,129.31h0l-8-3.84,2.08-1,5.92,2.84,5.92-2.84,2.08,1-8,3.84Z" transform="translate(348.359 -93.584)"/>
                <path id="Path_288_1_" d="M890.82,117.63l8,3.84-8,3.84-8-3.84Z" transform="translate(348.359 -93.584)"/>
                </g>
            </svg>
        </div>

        <chart-ordering
            :can-delete="canDelete"
            :can-update="canUpdate"
            :open="open"
        ></chart-ordering>
    </div>
</template>

<script>
    import { call, get, sync } from 'vuex-pathify'
    import ChartOrdering from './chartOrdering'
    import Draggable from 'vuedraggable'

    export default {
        props: {
            canDelete: {
                type: Boolean,
                default: false
            },

            canUpdate: {
                type: Boolean,
                default: false
            },
        },

        components: {
            ChartOrdering,
            Draggable,
        },

        data() {
            return {
                open: false,
            }
        },

        computed: {
            charts: sync('charts/charts'),
            currentClient: get('auth/client'),

            hasCharts() {
                return this.charts && this.charts.length > 0
            },

            iconClasses() {
                return {
                    'fill-pink': this.isOpen,
                    'fill-white': !this.isOpen && this.hasCharts,
                    'fill-blue-lightest': !this.hasCharts,
                }
            },

            isOpen() {
                return this.open
            },

            openClasses() {
                return {
                    'bg-blue-darkest': !this.isOpen,
                    'bg-blue-dark': this.isOpen,
                    'hover:bg-blue-dark': this.hasCharts,
                }
            },
        },

        methods: {
            destroy: call('charts/destroy'),
            updateOrder: call('clients/updateOrder'),

            onDelete(chart) {
                this.destroy(chart)
            },

            onEnd() {
                let sorted = []

                this.charts = this.charts.map((chart, index) => {
                    sorted.push({chart_id: chart.id, order: index})

                    chart.order = index

                    return chart
                })

                this.updateOrder({client: this.currentClient, sorted: sorted})
            },

            onOpen() {
                if (this.hasCharts) {
                    this.open = !this.open
                }
            },
        }
    }
</script>
